// controllers/useJoinLobbyController.js
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getPersistentUserId } from '@api/userService.js';
import { useLobby } from '@features/lobby/hooks/useLobby.js';

export function useLobbyJoinController() {
    const { code } = useParams();
    const [name, setName] = useState('');
    const [lobbyCode, setLobbyCode] = useState(code || '');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isPrivate, setIsPrivate] = useState(false); // aktuell nicht verwendet, aber kann ergänzt werden
    const navigate = useNavigate();
    const { joinLobby } = useLobby();

    useEffect(() => {
        if (code) {
            setLobbyCode(code);
        }
    }, [code]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setError('Bitte gib deinen Namen ein!');
            return;
        }

        if (!lobbyCode.trim()) {
            setError('Bitte gib einen Lobby-Code ein!');
            return;
        }

        const persistentId = getPersistentUserId();

        try {
            const resp = await joinLobby({ lobbyCode, name, persistentId, password });

            if (resp.success) {
                if (resp.gameStarted) {
                    navigate(`/game/${resp.gameType}/${lobbyCode}`);
                } else {
                    navigate(`/lobby/${lobbyCode}`);
                }
            } else {
                setError(resp.message);
            }
        } catch (err) {
            console.error('Fehler beim Beitreten:', err);
            setError('Unbekannter Fehler beim Beitreten der Lobby');
        }
    };

    return {
        name,
        setName,
        lobbyCode,
        setLobbyCode,
        password,
        setPassword,
        error,
        handleSubmit,
        isPrivate
    };
}
